<main>
  <loading-overlay [isLoading]="isLoading() > 0 || !enumsReady()" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Withholdings_Title' | translateWF: 'Withholding Certificates' }}</h1>
        <div class="page__title_buttons">
          <p-button [label]="'New' | translateWF: 'New'" icon="pi pi-plus" (click)="createNew()" />
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'Withholdings_Title' | translateWF: 'Withholding Certificates'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="retentions()" selectionMode="single" [lazy]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'Withholding_Certificate' | translateWF: 'Certificate #' }}</th>
                <th>{{ 'Withholding_Documents' | translateWF: 'AP documents' }}</th>
                <th>{{ 'Withholding_Code' | translateWF: 'Tax' }}</th>
                <th>{{ 'ApDocument_Provider' | translateWF: 'Provider' }}</th>
                <th>{{ 'ApDocument_DocumentDate' | translateWF: 'Date' }}</th>
                <th class="text-right">{{ 'Withholding_Retained' | translateWF: 'Retained' }}</th>
                <th>{{ 'Status' | translateWF: 'Status' }}</th>
                <th>{{ 'WithholdingRemittance_Remitted' | translateWF: 'Remitted' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let doc = getRowData(rowData);
              <tr>
                <td>
                  <a class="cs-table-link" (click)="openDetails(doc.id ?? undefined)">{{ doc.number }}</a>
                </td>
                <td>
                  <!-- #4893 — the certificate cites the document's fiscal number, so show that above ours.
                       #5122 — a foreign provider's certificate can cite several, so the first is named and
                       the rest counted rather than one of many being shown as though it were the only one.
                       Not clickable: this column names the document, the first one opens the certificate. -->
                  <app-document-identity [documentNumber]="firstSource(doc)?.number" [fiscalNumber]="firstSource(doc)?.fiscalNumber" [clickable]="false" />
                  @if (extraSourceCount(doc) > 0) {
                    <p-tag severity="info" [value]="'+' + extraSourceCount(doc) + ' ' + ('Withholding_MoreDocuments' | translateWF: 'more')" styleClass="mt-1" />
                  }
                </td>
                <td>{{ doc.withholdingCode || '—' }}</td>
                <td>{{ providerDisplay(doc) }}</td>
                <td>{{ doc.documentDate | date: 'dd/MM/yyyy' }}</td>
                <td class="text-right">{{ doc.totalAmount | number: '1.2-2' }} {{ currencyLabel(doc.currency) }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(doc.status)" [value]="statusLabel(doc.status)" />
                </td>
                <td>
                  @if (doc.remittedDate) {
                    <p-tag severity="success" [value]="('WithholdingRemittance_Remitted' | translateWF: 'Remitted') + ' · ' + (doc.remittedDate | date: 'dd/MM/yyyy')" />
                  } @else {
                    <p-tag severity="secondary" [value]="'WithholdingRemittance_Pending' | translateWF: 'Pending'" />
                  }
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8">{{ 'Withholdings_NotFound' | translateWF: 'No withholding certificates found' }}</td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
